import {
	AfterContentInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ContentChild,
	Input,
	OnInit,
} from '@angular/core';
import { DataRequestOption, SortOrder } from '@app/infrastructure/data-list/grid/api-grid/api';
import { IFilters } from '@app/infrastructure/data-list/grid/api-grid-filters/filters';
import { IGridColumnConfig } from '@app/infrastructure/data-list/grid/grid-column-config.model';
import { CustomHeaderDirective } from '@app/infrastructure/data-list/grid/sort-header/custom-header.directive';
import { UnsubscribeService } from '@app/infrastructure/unsubscribe/unsubscribe.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-sort-header',
	template: `
		<div class="d-flex align-items-center w-100">
			<ng-container [ngTemplateOutlet]="customHeaderContent ? customHeaderContent.templateRef : defaultContent">
			</ng-container>
			<mat-icon
				class="filter-icon ml-1"
				[ngClass]="{
					'icon-sort_descending': sortOrder === order.desc,
					'icon-sort_ascending': sortOrder === order.asc,
					grey: !isSorted,
					black: isSorted
				}"
				(click)="sort()"
				>arrow_downward</mat-icon
			>
		</div>

		<ng-template #defaultContent>
			<span class="text-truncate" appFullTextTooltip> {{ column?.name || '' }} </span>
		</ng-template>
	`,
	styleUrls: ['sort-header.component.scss'],
	providers: [UnsubscribeService],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortHeaderComponent implements OnInit, AfterContentInit {
	@Input() public column?: IGridColumnConfig<unknown>;
	@Input() public filter?: IFilters<unknown>;

	@ContentChild(CustomHeaderDirective) public customHeaderContent: CustomHeaderDirective | undefined;

	public sortOrder?: SortOrder = SortOrder.asc;
	public order = SortOrder;
	public isSorted = false;

	constructor(private unsubscribe$: UnsubscribeService, private changeDetectorRef: ChangeDetectorRef) {}

	public ngOnInit(): void {
		this.filter
			?.changes()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((options) => {
				const { sortColumn } = options as DataRequestOption<unknown>;
				this.isSorted = sortColumn?.columnName === this.column?.prop;
				this.sortOrder = sortColumn?.columnName === this.column?.prop ? sortColumn?.sortOrder : SortOrder.asc;
				this.changeDetectorRef.detectChanges();
			});
	}

	public ngAfterContentInit(): void {
		this.changeDetectorRef.detectChanges();
	}

	public sort(): void {
		const order = this.isSorted && this.sortOrder === SortOrder.asc ? SortOrder.desc : SortOrder.asc;
		this.filter?.sort(this.column?.prop ?? '', order);
	}
}
